module.exports = __webpack_public_path__ + "img/VN.c3be4f7e.svg";